import { SanityDocument } from '@sanity/client';

export const determineLinkForwarding = (item: SanityDocument) => {
  if (item?.callToActionURL) {
    return item.callToActionURL;
  }
  return `/content/${item.path}`;
};
